module.exports = __webpack_public_path__ + "media/your_career_track/career-mapping-9a24148d.jpg";